/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaBell: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="bell" viewBox="0 0 8 8">
      <path
        d="M5.99996 4.66671V3.00004C5.99996 1.89537 5.10462 1.00004 3.99996 1.00004C2.89529 1.00004 1.99996 1.89537 1.99996 3.00004V4.66671C1.99996 4.90971 1.93496 5.13737 1.82162 5.33337H6.17829C6.06496 5.13737 5.99996 4.90971 5.99996 4.66671ZM7.33329 6.00004H0.666624C0.222291 6.00004 0.222291 5.33337 0.666624 5.33337C1.03496 5.33337 1.33329 5.03504 1.33329 4.66671V3.00004C1.33329 1.52737 2.52729 0.333374 3.99996 0.333374C5.47262 0.333374 6.66662 1.52737 6.66662 3.00004V4.66671C6.66662 5.03504 6.96496 5.33337 7.33329 5.33337C7.77762 5.33337 7.77762 6.00004 7.33329 6.00004ZM4.86496 7.16737C4.68596 7.47571 4.35662 7.66571 3.99996 7.66571C3.64329 7.66571 3.31396 7.47604 3.13496 7.16737C3.00596 6.94504 3.16629 6.66671 3.42329 6.66671H4.57662C4.83362 6.66671 4.99396 6.94504 4.86496 7.16737Z"
        fill="#FBFBFC"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaBell)
